import { downloadOptions } from '@/mocks/home';

export default function DownloadSection() {
  return (
    <section id="download" className="bg-background-50">
      <div className="mx-auto max-w-none px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="flex items-center gap-2 text-xs font-medium uppercase tracking-wider text-primary-600">
              <i className="ri-download-cloud-2-line" />
              Download Entry
            </p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">下载入口条</h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600">
              按设备选择对应安装包，全部为官方渠道直链，下载前可先核对版本号与体积。
            </p>
          </div>
          <span className="inline-flex items-center gap-2 self-start rounded-full border border-accent-200 bg-accent-50 px-3 py-1.5 text-xs text-accent-700 md:self-auto">
            <i className="ri-refresh-line" />
            更新时间 2026-09-28
          </span>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-5" data-product-shop>
          {downloadOptions.map((opt) => (
            <div
              key={opt.key}
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 hover:bg-primary-50/40 md:p-5"
            >
              <div className="flex items-start justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-100 text-xl text-primary-600">
                  <i className={opt.icon} />
                </span>
                <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] font-medium text-secondary-900">
                  {opt.tag}
                </span>
              </div>

              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{opt.platform}</h3>
              <p className="mt-1 text-xs text-foreground-500">{opt.detail}</p>

              <dl className="mt-4 grid grid-cols-2 gap-y-2 border-t border-background-200 pt-4 text-xs">
                <div>
                  <dt className="text-foreground-500">版本</dt>
                  <dd className="mt-0.5 font-medium text-foreground-900">{opt.version}</dd>
                </div>
                <div>
                  <dt className="text-foreground-500">体积</dt>
                  <dd className="mt-0.5 font-medium text-foreground-900">{opt.size}</dd>
                </div>
                <div className="col-span-2">
                  <dt className="text-foreground-500">适配</dt>
                  <dd className="mt-0.5 font-medium text-foreground-900">{opt.fit}</dd>
                </div>
              </dl>

              <button
                type="button"
                className="mt-5 flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors group-hover:bg-primary-600"
              >
                <i className="ri-download-line" />
                获取安装包
              </button>
            </div>
          ))}
        </div>

        <div className="mt-5 flex flex-col items-start gap-3 rounded-lg border border-background-200 bg-background-100 px-4 py-3.5 text-xs text-foreground-600 sm:flex-row sm:items-center sm:justify-between">
          <span className="flex items-center gap-2">
            <i className="ri-qr-code-line text-base text-primary-600" />
            电脑端可直接使用网页版，手机扫码后数据实时互通
          </span>
          <span className="flex items-center gap-2">
            <i className="ri-shield-check-line text-base text-accent-600" />
            全部安装包均通过签名校验
          </span>
        </div>
      </div>
    </section>
  );
}